import { createReducer, on } from '@ngrx/store';
import {
  clearCC,
  deleteCustomComponent,
  getAllCustomComponent,
  getAllCustomComponentForApp,
  getCustomComponent,
  saveCustomComponent,
  sentCustomComponents,
  sentDeleteCustomComponent,
  setAllCustomComponent,
  setAllCustomComponentForApp,
  setAllCustomComponentWthSorting,
  setCustomComponent,
  updateCustomComponent
} from '../actions/customcomponent.actions';

export interface CustomComponentState {
  allCCs: any;
  getAllCCApiConstants: any;
  ccId: any;
  ccData: any;
  getCCcApiConstants: any;
  currentCC: any;
  loader: boolean;
  data: any;
}

export const initialState: CustomComponentState = {
  allCCs: [],
  getAllCCApiConstants: null,
  ccId: null,
  ccData: null,
  getCCcApiConstants: null,
  currentCC: null,
  loader: true,
  data: null
};

export const ccReducer = createReducer(
  initialState,
  on(getCustomComponent, (state, { getCCcApiConstants, ccId }) => ({
    ...state,
    ...{ getCCcApiConstants },
    ...{ ccId },
    loader: true
  })),
  on(clearCC, (state) => ({
    ...state,
    currentCC: null
  })),
  on(setCustomComponent, (state, { currentCC }) => ({
    ...state,
    currentCC: currentCC,
    loader: false
  })),
  on(sentCustomComponents, (state) => {
    return {
      ...state,
      newDocument: '',
      loader: true,
      data: null
    };
  }),
  on(saveCustomComponent, (state, { ccData }) => {
    return {
      ...state,
      data: ccData,
      loader: false
    };
  }),
  on(updateCustomComponent, (state, { saveCCApiConstants, ccData }) => {
    return {
      ...state,
      ...{ ccData },
      ...{ saveCCApiConstants },
      loader: false
    };
  }),
  on(deleteCustomComponent, (state, { ccId }) => {
    const allCCData = state.allCCs;
    const filteredData = allCCData.filter((component: { sid: string }) => component.sid !== ccId);
    return {
      ...state,
      allCCs: filteredData,
      loader: false
    };
  }),
  on(sentDeleteCustomComponent, (state, { ccId }) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(getAllCustomComponent, (state, { getAllCCApiConstants }) => {
    return {
      ...state,
      ...{ getAllCCApiConstants },
      loader: true
    };
  }),
  on(setAllCustomComponent, (state, { allCCs }) => {
    return {
      ...state,
      ...{ allCCs },
      loader: false
    };
  }),

  on(setAllCustomComponentWthSorting, (state, { allCCs }) => {
    return {
      ...state,
      ...{ allCCs },
      loader: false
    };
  }),
  on(getAllCustomComponentForApp, (state, { getAllCCForApp }) => {
    return {
      ...state,
      ...{ getAllCCForApp },
      loader: true
    };
  }),
  on(setAllCustomComponentForApp, (state, { allCCForApp }) => {
    return {
      ...state,
      ...{ allCCForApp },
      loader: false
    };
  })
);
